import { keys, pickBy } from 'lodash'

export const insertIf = <T>(condition: boolean | undefined, ...elements: T[]) => {
  return condition ? elements : []
}

export const removeDiacritics = (str: string): string => {
  return typeof str === 'string' ? str.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : str
}

export const getKeysWithTruthyValues = (obj: Record<string, boolean | string | undefined>) => keys(pickBy(obj))
